	// ב"ה
import React from 'react';
import { BrowserRouter as Router } from "react-router-dom";

import { createRoot } from 'react-dom/client';

import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import axios from 'axios';

axios.interceptors.request.use(
  request => {
    const idToken = localStorage.getItem('id_token') || sessionStorage.getItem('id_token');
    request.headers['Authorization'] = `Bearer ${idToken}`;
    request.headers['ngrok-skip-browser-warning'] = 'true';
    return request
  },
  error => {
    return Promise.reject(error);
  }
)

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <Router>
      <App />
    </Router>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
serviceWorkerRegistration.register();

reportWebVitals();
